import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = Parameters<typeof DigiobcanApi.adminGetAiDecisions>[0];

export const adminGetAiDecisions = createQueryFn(
  QueryNameSpace.adminGetAiDecisions,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], number>) => {
    const [, params] = queryKey;

    return DigiobcanApi.adminGetAiDecisions({
      ...params,
      offset: pageParam,
    });
  },
);
